import {printTransferSheet} from "../network/PrintTransferSheetAPI";

export const PrintSheetReducer = (state, action) => {
    switch (action.type) {
        case "PRINT_TRANSFER_SHEET":
            const  {scannableIds, dispatcher} = action.data;
            printTransferSheet(scannableIds, dispatcher);
            return {...state, isLoading: true, isSuccess: true};
        case "PRINT_TRANSFER_SHEET_RESPONSE":
            return {...state, isLoading: false, isSuccess: true};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/transferSheet/reducers/PrintSheetReducer.js